<template>
  <div class="modal-actions">
    <template v-if="store.currentStep === 'input'">
      <sp-button
        variant="flat"
        color="primary"
        :disabled="previewDisabled"
        :data-testid="TestId.assignSpecialties.previewButton"
        @click="store.preview()"
      >
        {{ store.labels.preview }}
      </sp-button>
    </template>

    <template v-else>
      <sp-button
        variant="outlined"
        color="primary"
        :disabled="store.isSubmitting"
        :data-testid="TestId.assignSpecialties.backButton"
        @click="store.currentStep = 'input'"
      >
        {{ store.labels.back }}
      </sp-button>

      <sp-button
        variant="flat"
        color="primary"
        :disabled="store.confirmDisabled"
        :data-testid="TestId.assignSpecialties.confirmButton"
        @click="store.confirm()"
      >
        {{ store.labels.confirm }}
      </sp-button>
    </template>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { TestId } from "#/test-ids";
import { useAssignSpecialtiesStore } from "#ce/apps/SpAdmin/SpAssignSpecialtiesApp/store/assign-specialties";

const store = useAssignSpecialtiesStore();

const hasInput = computed(() => store.terms.length > 0 || !!store.inputText.trim() || !!store.termFile);
const previewDisabled = computed(
  () => store.isSubmitting || !hasInput.value || store.selectedSpecialtyIds.length === 0,
);
</script>

<style scoped lang="scss">
.modal-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--sp-ref-scale-8);
  width: 100%;
  padding-block: var(--sp-ref-scale-16);
  padding-inline: var(--sp-ref-scale-24);
  border-top: var(--sp-sys-border-width-default) solid var(--sp-sys-color-outline);

  /* SpButton reads -background-color (not -background), and both custom
   * properties need literal fallbacks: without them a missing sys token made
   * the disabled Preview button render transparent — i.e. invisible until its
   * preconditions enabled it. The button must always be visible, just disabled. */
  --sp-comp-button-disabled-background-color: var(--sp-sys-color-disabled, #ccc);
  --sp-comp-button-disabled-text-color: var(--sp-sys-color-on-disabled, #fff);
}
</style>
